import { CommonModule, DecimalPipe, DatePipe } from "@angular/common";
import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbDatepickerModule, NgbTimepickerModule, NgbDropdownModule, NgbDatepickerI18n } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { MaskitoDirective } from "@maskito/angular";
import { DefaultValidationMessageProvider } from "./common/default-validation-message-provider.service";
import { FormControlContainerComponent } from "./common/form-control-container/form-control-container.component";
import { TranslationProvider, EnglishTranslationProvider } from "./common/translation-provider";
import { ValidationMessageProvider } from "./common/validation-message-provider";
import { ValidationMessagesComponent } from "./common/validation-messages/validation-messages.component";
import { BooleanInputComponent } from "./controls/boolean-input/boolean-input.component";
import { CurrencyInputComponent } from "./controls/currency-input/currency-input.component";
import { DateInputComponent } from "./controls/date-input/date-input.component";
import { DefaultDatepickerI18n } from "./controls/date-input/default-datepicker-i18n.service";
import { MonthViewComponent } from "./controls/date-input/month-view/month-view.component";
import { EmailInputComponent } from "./controls/email-input/email-input.component";
import { NumberInputComponent } from "./controls/number-input/number-input.component";
import { PasswordInputComponent } from "./controls/password-input/password-input.component";
import { PercentInputComponent } from "./controls/percent-input/percent-input.component";
import { PhoneInputComponent } from "./controls/phone-input/phone-input.component";
import { PhotoInputComponent } from "./controls/photo-input/photo-input.component";
import { SelectInputComponent } from "./controls/select-input/select-input.component";
import { SelectOptionTemplateDirective, SelectLabelTemplateDirective, SelectReadonlyLabelTemplateDirective } from "./controls/select-input/select-templates.directive";
import { TextInputComponent } from "./controls/text-input/text-input.component";
import { TimeInputComponent } from "./controls/time-input/time-input.component";
import { BoolToDisplayValuePipe } from "./pipes/bool-to-display-value.pipe";
import { CurrencyStringPipe } from "./pipes/currency-string.pipe";
import { DateTimeStringPipe } from "./pipes/date-time-string.pipe";
import { EmailToDisplayValuePipe } from "./pipes/email-to-display-value.pipe";
import { ListOptionToDisplayValuePipe } from "./pipes/list-option-to-display-value.pipe";
import { NumberStringPipe } from "./pipes/number-string.pipe";
import { PercentStringPipe } from "./pipes/percent-string.pipe";
import { ShortDateStringPipe } from "./pipes/short-date-string.pipe";
import { TimeStringPipe } from "./pipes/time-string.pipe";
import { ConfigurationManager } from "./services/configuration-manager.service";
import { TCMEmailValidator } from "./validators/email";


const controls = [
  TextInputComponent,
  EmailInputComponent,
  PhoneInputComponent,
  CurrencyInputComponent,
  BooleanInputComponent,
  PasswordInputComponent,
  SelectInputComponent,
  NumberInputComponent,
  DateInputComponent,
  PhotoInputComponent,
  TimeInputComponent,
  PercentInputComponent
];

const pipes = [
  ListOptionToDisplayValuePipe,
  EmailToDisplayValuePipe,
  BoolToDisplayValuePipe,
  ShortDateStringPipe,
  DateTimeStringPipe,
  TimeStringPipe,
  CurrencyStringPipe,
  NumberStringPipe,
  PercentStringPipe
];

@NgModule({
  declarations: [
      FormControlContainerComponent,
      ValidationMessagesComponent,
      controls,
      MonthViewComponent,
      SelectOptionTemplateDirective,
      SelectLabelTemplateDirective,
      SelectReadonlyLabelTemplateDirective,
      pipes,
      TCMEmailValidator
  ],
  imports: [
      CommonModule,
      FormsModule,
      NgbDatepickerModule,
      NgbTimepickerModule,
      NgbDropdownModule,
      NgSelectModule,
      MaskitoDirective,
  ],
  exports: [
      FormControlContainerComponent,
      ValidationMessagesComponent,
      SelectOptionTemplateDirective,
      SelectLabelTemplateDirective,
      SelectReadonlyLabelTemplateDirective,
      controls,
      pipes,
      TCMEmailValidator,
      MaskitoDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TCMFormModule {
  public static forRoot(): ModuleWithProviders<TCMFormModule> {
      return {
          ngModule: TCMFormModule,
          providers: [
              DecimalPipe,
              DatePipe,
              pipes,
              ConfigurationManager,
              { provide: ValidationMessageProvider, useClass: DefaultValidationMessageProvider },
              { provide: NgbDatepickerI18n, useClass: DefaultDatepickerI18n },
              { provide: TranslationProvider, useClass: EnglishTranslationProvider }
          ]
      };
  }
}
